import type {CSSProperties, ReactElement} from 'react';
import {useContext} from 'react';
import classNames from 'classnames';
import {store} from '@components/Test/Context';
import type {Progress as ProgressType} from '@interfaces/Test';

export default function Progress(props: ProgressType): ReactElement<ProgressType> {
    const {currentState} = useContext(store);

    const handleClassName = classNames({
        'test-progress__handle': !props.handleIcon,
        'test-progress__handle--transparent': props.handleIcon,
    });

    function calculatePointPosition(currentScore: number): number {
        const range = props.max - props.min;
        const correctedCurrentScore = currentScore - props.min;
        return (correctedCurrentScore * 100) / range;
    }

    function calculateRootStyles(): CSSProperties {
        return props.backgroundColor ? {backgroundColor: props.backgroundColor} : {};
    }

    function calculateLeftIconStyles(): CSSProperties {
        return props.leftIcon ? {backgroundImage: `url("${props.leftIcon}")`} : {};
    }

    function calculateRightIconStyles(): CSSProperties {
        return props.rightIcon ? {backgroundImage: `url("${props.rightIcon}")`} : {};
    }

    function calculateHandleStyles(): CSSProperties {
        const result: CSSProperties = {
            left: `${calculatePointPosition(currentState.score)}%`,
        };

        if (props.handleIcon) {
            result.backgroundImage = `url("${props.handleIcon}")`;
        }
        return result;
    }

    return (
        <div className="test-progress" style={calculateRootStyles()}>
            <div className="test-progress__left-icon" style={calculateLeftIconStyles()} />
            <div className="test-progress__right-icon" style={calculateRightIconStyles()} />
            <div className="test-progress__bar">
                <div className={handleClassName} style={calculateHandleStyles()} />
            </div>
        </div>
    );
}
